var map = {
	"./Cursive/A/A_wdt_c_cap_0.mp3": 745,
	"./Cursive/A/A_wdt_c_cap_1.mp3": 746,
	"./Cursive/A/A_wdt_c_cap_2.mp3": 747,
	"./Cursive/A/A_wdt_c_cap_3.mp3": 748,
	"./Cursive/A/Snd_TryA.mp3": 749,
	"./Cursive/B/B_wdt_c_cap_0.mp3": 750,
	"./Cursive/B/B_wdt_c_cap_1.mp3": 751,
	"./Cursive/B/B_wdt_c_cap_2.mp3": 752,
	"./Cursive/B/B_wdt_c_cap_3.mp3": 753,
	"./Cursive/B/B_wdt_c_cap_4.mp3": 754,
	"./Cursive/B/Snd_TryB.mp3": 755,
	"./Cursive/C/C_wdt_c_cap_0.mp3": 756,
	"./Cursive/C/C_wdt_c_cap_1.mp3": 757,
	"./Cursive/C/Snd_TryC.mp3": 758,
	"./Cursive/D/D_wdt_c_cap_0.mp3": 759,
	"./Cursive/D/D_wdt_c_cap_1.mp3": 760,
	"./Cursive/D/D_wdt_c_cap_2.mp3": 761,
	"./Cursive/D/D_wdt_c_cap_3.mp3": 762,
	"./Cursive/D/D_wdt_c_cap_4.mp3": 763,
	"./Cursive/D/Snd_TryD.mp3": 764,
	"./Cursive/E/E_wdt_c_cap_0.mp3": 765,
	"./Cursive/E/E_wdt_c_cap_1.mp3": 766,
	"./Cursive/E/Snd_TryE.mp3": 767,
	"./Cursive/F/F_wdt_c_cap_0.mp3": 768,
	"./Cursive/F/F_wdt_c_cap_1.mp3": 769,
	"./Cursive/F/F_wdt_c_cap_2.mp3": 770,
	"./Cursive/F/F_wdt_c_cap_3.mp3": 771,
	"./Cursive/F/Snd_TryF.mp3": 772,
	"./Cursive/G/G_wdt_c_cap_0.mp3": 773,
	"./Cursive/G/G_wdt_c_cap_1.mp3": 774,
	"./Cursive/G/G_wdt_c_cap_2.mp3": 775,
	"./Cursive/G/G_wdt_c_cap_3.mp3": 776,
	"./Cursive/G/G_wdt_c_cap_4.mp3": 777,
	"./Cursive/G/Snd_TryG.mp3": 778,
	"./Cursive/H/H_wdt_c_cap_0.mp3": 779,
	"./Cursive/H/H_wdt_c_cap_1.mp3": 780,
	"./Cursive/H/H_wdt_c_cap_2.mp3": 781,
	"./Cursive/H/H_wdt_c_cap_3.mp3": 782,
	"./Cursive/H/H_wdt_c_cap_4.mp3": 783,
	"./Cursive/H/Snd_TryH.mp3": 784,
	"./Cursive/I/I_wdt_c_cap_0.mp3": 785,
	"./Cursive/I/I_wdt_c_cap_1.mp3": 786,
	"./Cursive/I/I_wdt_c_cap_2.mp3": 787,
	"./Cursive/I/I_wdt_c_cap_3.mp3": 788,
	"./Cursive/I/Snd_TryI.mp3": 789,
	"./Cursive/J/J_wdt_c_cap_0.mp3": 790,
	"./Cursive/J/J_wdt_c_cap_1.mp3": 791,
	"./Cursive/J/J_wdt_c_cap_2.mp3": 792,
	"./Cursive/J/J_wdt_c_cap_3.mp3": 793,
	"./Cursive/J/Snd_TryJ.mp3": 794,
	"./Cursive/K/K_wdt_c_cap_0.mp3": 795,
	"./Cursive/K/K_wdt_c_cap_1.mp3": 796,
	"./Cursive/K/K_wdt_c_cap_2.mp3": 797,
	"./Cursive/K/K_wdt_c_cap_3.mp3": 798,
	"./Cursive/K/K_wdt_c_cap_4.mp3": 799,
	"./Cursive/K/Snd_TryK.mp3": 800,
	"./Cursive/L/L_wdt_c_cap_0.mp3": 801,
	"./Cursive/L/L_wdt_c_cap_1.mp3": 802,
	"./Cursive/L/L_wdt_c_cap_2.mp3": 803,
	"./Cursive/L/L_wdt_c_cap_3.mp3": 804,
	"./Cursive/L/Snd_TryL.mp3": 805,
	"./Cursive/M/M_wdt_c_cap_0.mp3": 806,
	"./Cursive/M/M_wdt_c_cap_1.mp3": 807,
	"./Cursive/M/M_wdt_c_cap_2.mp3": 808,
	"./Cursive/M/M_wdt_c_cap_3.mp3": 809,
	"./Cursive/M/M_wdt_c_cap_4.mp3": 810,
	"./Cursive/M/M_wdt_c_cap_5.mp3": 811,
	"./Cursive/M/M_wdt_c_cap_6.mp3": 812,
	"./Cursive/M/Snd_TryM.mp3": 813,
	"./Cursive/N/N_wdt_c_cap_0.mp3": 814,
	"./Cursive/N/N_wdt_c_cap_1.mp3": 815,
	"./Cursive/N/N_wdt_c_cap_2.mp3": 816,
	"./Cursive/N/N_wdt_c_cap_3.mp3": 817,
	"./Cursive/N/N_wdt_c_cap_4.mp3": 818,
	"./Cursive/N/N_wdt_c_cap_5.mp3": 819,
	"./Cursive/N/Snd_TryN.mp3": 820,
	"./Cursive/O/O_wdt_c_cap_0.mp3": 821,
	"./Cursive/O/O_wdt_c_cap_1.mp3": 822,
	"./Cursive/O/O_wdt_c_cap_2.mp3": 823,
	"./Cursive/O/Snd_TryO.mp3": 824,
	"./Cursive/P/P_wdt_c_cap_0.mp3": 825,
	"./Cursive/P/P_wdt_c_cap_1.mp3": 826,
	"./Cursive/P/P_wdt_c_cap_2.mp3": 827,
	"./Cursive/P/P_wdt_c_cap_3.mp3": 828,
	"./Cursive/P/Snd_TryP.mp3": 829,
	"./Cursive/Q/Q_wdt_c_cap_0.mp3": 830,
	"./Cursive/Q/Q_wdt_c_cap_1.mp3": 831,
	"./Cursive/Q/Q_wdt_c_cap_2.mp3": 832,
	"./Cursive/Q/Snd_TryQ.mp3": 833,
	"./Cursive/R/R_wdt_c_cap_0.mp3": 834,
	"./Cursive/R/R_wdt_c_cap_1.mp3": 835,
	"./Cursive/R/R_wdt_c_cap_2.mp3": 836,
	"./Cursive/R/R_wdt_c_cap_3.mp3": 837,
	"./Cursive/R/R_wdt_c_cap_4.mp3": 838,
	"./Cursive/R/R_wdt_c_cap_5.mp3": 839,
	"./Cursive/R/Snd_TryR.mp3": 840,
	"./Cursive/S/S_wdt_c_cap_0.mp3": 841,
	"./Cursive/S/S_wdt_c_cap_1.mp3": 842,
	"./Cursive/S/S_wdt_c_cap_2.mp3": 843,
	"./Cursive/S/Snd_TryS.mp3": 844,
	"./Cursive/T/Snd_TryT.mp3": 845,
	"./Cursive/T/T_wdt_c_cap_0.mp3": 846,
	"./Cursive/T/T_wdt_c_cap_1.mp3": 847,
	"./Cursive/T/T_wdt_c_cap_2.mp3": 848,
	"./Cursive/U/Snd_TryU.mp3": 849,
	"./Cursive/U/U_wdt_c_cap_0.mp3": 850,
	"./Cursive/U/U_wdt_c_cap_1.mp3": 851,
	"./Cursive/U/U_wdt_c_cap_2.mp3": 852,
	"./Cursive/U/U_wdt_c_cap_3.mp3": 853,
	"./Cursive/V/Snd_TryV.mp3": 854,
	"./Cursive/V/V_wdt_c_cap_0.mp3": 855,
	"./Cursive/V/V_wdt_c_cap_1.mp3": 856,
	"./Cursive/V/V_wdt_c_cap_2.mp3": 857,
	"./Cursive/W/Snd_TryW.mp3": 858,
	"./Cursive/W/W_wdt_c_cap_0.mp3": 859,
	"./Cursive/W/W_wdt_c_cap_1.mp3": 860,
	"./Cursive/W/W_wdt_c_cap_2.mp3": 861,
	"./Cursive/W/W_wdt_c_cap_3.mp3": 862,
	"./Cursive/X/Snd_TryX.mp3": 863,
	"./Cursive/X/X_wdt_c_cap_0.mp3": 864,
	"./Cursive/X/X_wdt_c_cap_1.mp3": 865,
	"./Cursive/Y/Snd_TryY.mp3": 866,
	"./Cursive/Y/Y_wdt_c_cap_0.mp3": 867,
	"./Cursive/Y/Y_wdt_c_cap_1.mp3": 868,
	"./Cursive/Y/Y_wdt_c_cap_2.mp3": 869,
	"./Cursive/Y/Y_wdt_c_cap_3.mp3": 870,
	"./Cursive/Y/Y_wdt_c_cap_4.mp3": 871,
	"./Cursive/Z/Snd_TryZ.mp3": 872,
	"./Cursive/Z/Z_wdt_c_cap_0.mp3": 873,
	"./Cursive/Z/Z_wdt_c_cap_1.mp3": 874,
	"./Cursive/Z/Z_wdt_c_cap_2.mp3": 875,
	"./Cursive/Z/Z_wdt_c_cap_3.mp3": 876,
	"./Cursive/lowerA/Snd_TryA.mp3": 877,
	"./Cursive/lowerA/a_wdt_c_0.mp3": 878,
	"./Cursive/lowerA/a_wdt_c_1.mp3": 879,
	"./Cursive/lowerA/a_wdt_c_1_2.mp3": 880,
	"./Cursive/lowerA/a_wdt_c_2.mp3": 881,
	"./Cursive/lowerA/a_wdt_c_3.mp3": 882,
	"./Cursive/lowerA/a_wdt_c_3_4.mp3": 883,
	"./Cursive/lowerA/a_wdt_c_4.mp3": 884,
	"./Cursive/lowerA/a_wdt_c_5.mp3": 885,
	"./Cursive/lowerAD/ad_0.mp3": 886,
	"./Cursive/lowerAD/ad_1.mp3": 887,
	"./Cursive/lowerAD/ad_2.mp3": 888,
	"./Cursive/lowerAD/ad_3.mp3": 889,
	"./Cursive/lowerAD/ad_4.mp3": 890,
	"./Cursive/lowerAD/ad_5.mp3": 891,
	"./Cursive/lowerAD/ad_6.mp3": 892,
	"./Cursive/lowerAD/ad_7.mp3": 893,
	"./Cursive/lowerB/Snd_TryB.mp3": 894,
	"./Cursive/lowerB/b_wdt_c_0.mp3": 895,
	"./Cursive/lowerB/b_wdt_c_0_1.mp3": 896,
	"./Cursive/lowerB/b_wdt_c_1.mp3": 897,
	"./Cursive/lowerB/b_wdt_c_2.mp3": 898,
	"./Cursive/lowerB/b_wdt_c_3.mp3": 899,
	"./Cursive/lowerB/b_wdt_c_4.mp3": 900,
	"./Cursive/lowerB/b_wdt_c_5.mp3": 901,
	"./Cursive/lowerBO/bo_0.mp3": 902,
	"./Cursive/lowerBO/bo_1.mp3": 903,
	"./Cursive/lowerBO/bo_3.mp3": 904,
	"./Cursive/lowerBO/bo_4.mp3": 905,
	"./Cursive/lowerBO/bo_5.mp3": 906,
	"./Cursive/lowerBO/bo_6.mp3": 907,
	"./Cursive/lowerBO/bo_7.mp3": 908,
	"./Cursive/lowerBO/bo_8.mp3": 909,
	"./Cursive/lowerBY/by_0.mp3": 910,
	"./Cursive/lowerBY/by_1.mp3": 911,
	"./Cursive/lowerBY/by_10.mp3": 912,
	"./Cursive/lowerBY/by_11.mp3": 913,
	"./Cursive/lowerBY/by_12.mp3": 914,
	"./Cursive/lowerBY/by_3.mp3": 915,
	"./Cursive/lowerBY/by_4.mp3": 916,
	"./Cursive/lowerBY/by_5.mp3": 917,
	"./Cursive/lowerBY/by_6.mp3": 918,
	"./Cursive/lowerBY/by_7.mp3": 919,
	"./Cursive/lowerBY/by_8.mp3": 920,
	"./Cursive/lowerBY/by_9.mp3": 921,
	"./Cursive/lowerC/Snd_TryC.mp3": 922,
	"./Cursive/lowerC/c_wdt_c_0.mp3": 923,
	"./Cursive/lowerCC/cc_0.mp3": 924,
	"./Cursive/lowerCC/cc_1.mp3": 925,
	"./Cursive/lowerCC/cc_2.mp3": 926,
	"./Cursive/lowerCC/cc_3.mp3": 927,
	"./Cursive/lowerCH/ch_0.mp3": 928,
	"./Cursive/lowerCH/ch_1.mp3": 929,
	"./Cursive/lowerCH/ch_2.mp3": 930,
	"./Cursive/lowerCH/ch_3.mp3": 931,
	"./Cursive/lowerCH/ch_4.mp3": 932,
	"./Cursive/lowerCH/ch_5.mp3": 933,
	"./Cursive/lowerD/Snd_TryD.mp3": 934,
	"./Cursive/lowerD/d_wdt_c_0.mp3": 935,
	"./Cursive/lowerD/d_wdt_c_1.mp3": 936,
	"./Cursive/lowerD/d_wdt_c_1_2.mp3": 937,
	"./Cursive/lowerD/d_wdt_c_2.mp3": 938,
	"./Cursive/lowerD/d_wdt_c_3.mp3": 939,
	"./Cursive/lowerD/d_wdt_c_3_4.mp3": 940,
	"./Cursive/lowerD/d_wdt_c_4.mp3": 941,
	"./Cursive/lowerD/d_wdt_c_5.mp3": 942,
	"./Cursive/lowerE/Snd_TryE.mp3": 943,
	"./Cursive/lowerE/e_wdt_c_0.mp3": 944,
	"./Cursive/lowerE/e_wdt_c_0_1_2.mp3": 945,
	"./Cursive/lowerE/e_wdt_c_1.mp3": 946,
	"./Cursive/lowerE/e_wdt_c_2.mp3": 947,
	"./Cursive/lowerE/e_wdt_c_3.mp3": 948,
	"./Cursive/lowerE/e_wdt_c_4.mp3": 949,
	"./Cursive/lowerE/e_wdt_c_4_5.mp3": 950,
	"./Cursive/lowerE/e_wdt_c_5.mp3": 951,
	"./Cursive/lowerE/e_wdt_c_6.mp3": 952,
	"./Cursive/lowerED/ed_0.mp3": 953,
	"./Cursive/lowerED/ed_1.mp3": 954,
	"./Cursive/lowerED/ed_2.mp3": 955,
	"./Cursive/lowerED/ed_3.mp3": 956,
	"./Cursive/lowerED/ed_4.mp3": 957,
	"./Cursive/lowerED/ed_5.mp3": 958,
	"./Cursive/lowerED/ed_6.mp3": 959,
	"./Cursive/lowerED/ed_7.mp3": 960,
	"./Cursive/lowerEL/el_0.mp3": 961,
	"./Cursive/lowerEL/el_1.mp3": 962,
	"./Cursive/lowerEL/el_2.mp3": 963,
	"./Cursive/lowerEL/el_3.mp3": 964,
	"./Cursive/lowerEL/el_4.mp3": 965,
	"./Cursive/lowerEL/el_5.mp3": 966,
	"./Cursive/lowerEL/el_6.mp3": 967,
	"./Cursive/lowerF/Snd_TryF.mp3": 968,
	"./Cursive/lowerF/f_wdt_c_0.mp3": 969,
	"./Cursive/lowerF/f_wdt_c_0_1.mp3": 970,
	"./Cursive/lowerF/f_wdt_c_1.mp3": 971,
	"./Cursive/lowerF/f_wdt_c_2.mp3": 972,
	"./Cursive/lowerF/f_wdt_c_3.mp3": 973,
	"./Cursive/lowerF/f_wdt_c_4.mp3": 974,
	"./Cursive/lowerF/f_wdt_c_4_5.mp3": 975,
	"./Cursive/lowerF/f_wdt_c_5.mp3": 976,
	"./Cursive/lowerF/f_wdt_c_6.mp3": 977,
	"./Cursive/lowerG/Snd_TryG.mp3": 978,
	"./Cursive/lowerG/g_wdt_c_0.mp3": 979,
	"./Cursive/lowerG/g_wdt_c_1.mp3": 980,
	"./Cursive/lowerG/g_wdt_c_1_2.mp3": 981,
	"./Cursive/lowerG/g_wdt_c_2.mp3": 982,
	"./Cursive/lowerG/g_wdt_c_3.mp3": 983,
	"./Cursive/lowerG/g_wdt_c_4.mp3": 984,
	"./Cursive/lowerG/g_wdt_c_4_5.mp3": 985,
	"./Cursive/lowerG/g_wdt_c_5.mp3": 986,
	"./Cursive/lowerG/g_wdt_c_6.mp3": 987,
	"./Cursive/lowerGL/gl_1.mp3": 988,
	"./Cursive/lowerGL/gl_2.mp3": 989,
	"./Cursive/lowerGL/gl_3.mp3": 990,
	"./Cursive/lowerGL/gl_4.mp3": 991,
	"./Cursive/lowerGL/gl_5.mp3": 992,
	"./Cursive/lowerGL/gl_6.mp3": 993,
	"./Cursive/lowerGL/gl_7.mp3": 994,
	"./Cursive/lowerH/Snd_TryH.mp3": 995,
	"./Cursive/lowerH/h_wdt_c_0.mp3": 996,
	"./Cursive/lowerH/h_wdt_c_1.mp3": 997,
	"./Cursive/lowerH/h_wdt_c_1_2.mp3": 998,
	"./Cursive/lowerH/h_wdt_c_2.mp3": 999,
	"./Cursive/lowerH/h_wdt_c_3.mp3": 1000,
	"./Cursive/lowerH/h_wdt_c_3_4.mp3": 1001,
	"./Cursive/lowerH/h_wdt_c_4.mp3": 1002,
	"./Cursive/lowerH/h_wdt_c_5.mp3": 1003,
	"./Cursive/lowerI/Snd_TryI.mp3": 1004,
	"./Cursive/lowerI/i_wdt_c_0.mp3": 1005,
	"./Cursive/lowerI/i_wdt_c_0_1.mp3": 1006,
	"./Cursive/lowerI/i_wdt_c_1.mp3": 1007,
	"./Cursive/lowerI/i_wdt_c_2.mp3": 1008,
	"./Cursive/lowerI/i_wdt_c_2_3.mp3": 1009,
	"./Cursive/lowerI/i_wdt_c_3.mp3": 1010,
	"./Cursive/lowerI/i_wdt_c_4.mp3": 1011,
	"./Cursive/lowerI/i_wdt_c_5.mp3": 1012,
	"./Cursive/lowerIT/it_0.mp3": 1013,
	"./Cursive/lowerIT/it_1.mp3": 1014,
	"./Cursive/lowerIT/it_2.mp3": 1015,
	"./Cursive/lowerIT/it_3.mp3": 1016,
	"./Cursive/lowerIT/it_4.mp3": 1017,
	"./Cursive/lowerIT/it_6.mp3": 1018,
	"./Cursive/lowerIT/it_8.mp3": 1019,
	"./Cursive/lowerJ/Snd_TryJ.mp3": 1020,
	"./Cursive/lowerJ/j_wdt_c_0.mp3": 1021,
	"./Cursive/lowerJ/j_wdt_c_0_1.mp3": 1022,
	"./Cursive/lowerJ/j_wdt_c_1.mp3": 1023,
	"./Cursive/lowerJ/j_wdt_c_2.mp3": 1024,
	"./Cursive/lowerJ/j_wdt_c_3.mp3": 1025,
	"./Cursive/lowerJ/j_wdt_c_4.mp3": 1026,
	"./Cursive/lowerJ/j_wdt_c_4_5.mp3": 1027,
	"./Cursive/lowerJ/j_wdt_c_5.mp3": 1028,
	"./Cursive/lowerJ/j_wdt_c_6.mp3": 1029,
	"./Cursive/lowerK/Snd_TryK.mp3": 1030,
	"./Cursive/lowerK/k_wdt_c_0.mp3": 1031,
	"./Cursive/lowerK/k_wdt_c_1.mp3": 1032,
	"./Cursive/lowerK/k_wdt_c_1_2.mp3": 1033,
	"./Cursive/lowerK/k_wdt_c_2.mp3": 1034,
	"./Cursive/lowerK/k_wdt_c_3.mp3": 1035,
	"./Cursive/lowerK/k_wdt_c_3_4.mp3": 1036,
	"./Cursive/lowerK/k_wdt_c_4.mp3": 1037,
	"./Cursive/lowerK/k_wdt_c_4_5.mp3": 1038,
	"./Cursive/lowerK/k_wdt_c_5.mp3": 1039,
	"./Cursive/lowerK/k_wdt_c_6.mp3": 1040,
	"./Cursive/lowerK/k_wdt_c_6_7.mp3": 1041,
	"./Cursive/lowerK/k_wdt_c_7.mp3": 1042,
	"./Cursive/lowerL/Snd_TryL.mp3": 1043,
	"./Cursive/lowerL/l_wdt_c_0.mp3": 1044,
	"./Cursive/lowerL/l_wdt_c_0_1.mp3": 1045,
	"./Cursive/lowerL/l_wdt_c_1.mp3": 1046,
	"./Cursive/lowerL/l_wdt_c_2.mp3": 1047,
	"./Cursive/lowerL/l_wdt_c_3.mp3": 1048,
	"./Cursive/lowerL/l_wdt_c_4.mp3": 1049,
	"./Cursive/lowerL/l_wdt_c_4_5.mp3": 1050,
	"./Cursive/lowerL/l_wdt_c_5.mp3": 1051,
	"./Cursive/lowerM/Snd_TryM.mp3": 1052,
	"./Cursive/lowerM/m_wdt_c_0.mp3": 1053,
	"./Cursive/lowerM/m_wdt_c_1.mp3": 1054,
	"./Cursive/lowerM/m_wdt_c_2.mp3": 1055,
	"./Cursive/lowerM/m_wdt_c_3.mp3": 1056,
	"./Cursive/lowerM/m_wdt_c_4.mp3": 1057,
	"./Cursive/lowerM/m_wdt_c_5.mp3": 1058,
	"./Cursive/lowerM/m_wdt_c_6.mp3": 1059,
	"./Cursive/lowerM/m_wdt_c_7.mp3": 1060,
	"./Cursive/lowerN/Snd_TryN.mp3": 1061,
	"./Cursive/lowerN/n_wdt_c_0.mp3": 1062,
	"./Cursive/lowerN/n_wdt_c_1.mp3": 1063,
	"./Cursive/lowerN/n_wdt_c_2.mp3": 1064,
	"./Cursive/lowerN/n_wdt_c_3.mp3": 1065,
	"./Cursive/lowerN/n_wdt_c_4.mp3": 1066,
	"./Cursive/lowerN/n_wdt_c_5.mp3": 1067,
	"./Cursive/lowerO/Snd_TryO.mp3": 1068,
	"./Cursive/lowerO/o_wdt_c_0.mp3": 1069,
	"./Cursive/lowerO/o_wdt_c_1.mp3": 1070,
	"./Cursive/lowerO/o_wdt_c_1_2.mp3": 1071,
	"./Cursive/lowerO/o_wdt_c_2.mp3": 1072,
	"./Cursive/lowerO/o_wdt_c_3.mp3": 1073,
	"./Cursive/lowerOA/oa_0.mp3": 1074,
	"./Cursive/lowerOA/oa_1.mp3": 1075,
	"./Cursive/lowerOA/oa_2.mp3": 1076,
	"./Cursive/lowerOA/oa_3.mp3": 1077,
	"./Cursive/lowerOA/oa_4.mp3": 1078,
	"./Cursive/lowerOA/oa_5.mp3": 1079,
	"./Cursive/lowerOA/oa_6.mp3": 1080,
	"./Cursive/lowerOE/oe_0.mp3": 1081,
	"./Cursive/lowerOE/oe_1.mp3": 1082,
	"./Cursive/lowerOE/oe_2.mp3": 1083,
	"./Cursive/lowerOE/oe_3.mp3": 1084,
	"./Cursive/lowerOE/oe_4.mp3": 1085,
	"./Cursive/lowerOE/oe_5.mp3": 1086,
	"./Cursive/lowerOF/of_0.mp3": 1087,
	"./Cursive/lowerOF/of_1.mp3": 1088,
	"./Cursive/lowerOF/of_2.mp3": 1089,
	"./Cursive/lowerOF/of_3.mp3": 1090,
	"./Cursive/lowerOF/of_4.mp3": 1091,
	"./Cursive/lowerOF/of_5.mp3": 1092,
	"./Cursive/lowerOF/of_6.mp3": 1093,
	"./Cursive/lowerOI/oi_0.mp3": 1094,
	"./Cursive/lowerOI/oi_1.mp3": 1095,
	"./Cursive/lowerOI/oi_2.mp3": 1096,
	"./Cursive/lowerOI/oi_3.mp3": 1097,
	"./Cursive/lowerOI/oi_4.mp3": 1098,
	"./Cursive/lowerOI/oi_6.mp3": 1099,
	"./Cursive/lowerON/on_0.mp3": 1100,
	"./Cursive/lowerON/on_1.mp3": 1101,
	"./Cursive/lowerON/on_2.mp3": 1102,
	"./Cursive/lowerON/on_3.mp3": 1103,
	"./Cursive/lowerON/on_4.mp3": 1104,
	"./Cursive/lowerON/on_6.mp3": 1105,
	"./Cursive/lowerOR/or_0.mp3": 1106,
	"./Cursive/lowerOR/or_1.mp3": 1107,
	"./Cursive/lowerOR/or_2.mp3": 1108,
	"./Cursive/lowerOR/or_3.mp3": 1109,
	"./Cursive/lowerOR/or_4.mp3": 1110,
	"./Cursive/lowerOR/or_5.mp3": 1111,
	"./Cursive/lowerOS/os_0.mp3": 1112,
	"./Cursive/lowerOS/os_1.mp3": 1113,
	"./Cursive/lowerOS/os_2.mp3": 1114,
	"./Cursive/lowerOS/os_3.mp3": 1115,
	"./Cursive/lowerOS/os_4.mp3": 1116,
	"./Cursive/lowerP/Snd_TryP.mp3": 1117,
	"./Cursive/lowerP/p_wdt_c_0.mp3": 1118,
	"./Cursive/lowerP/p_wdt_c_0_1.mp3": 1119,
	"./Cursive/lowerP/p_wdt_c_1.mp3": 1120,
	"./Cursive/lowerP/p_wdt_c_2.mp3": 1121,
	"./Cursive/lowerP/p_wdt_c_3.mp3": 1122,
	"./Cursive/lowerP/p_wdt_c_4.mp3": 1123,
	"./Cursive/lowerP/p_wdt_c_5.mp3": 1124,
	"./Cursive/lowerP/p_wdt_c_5_6.mp3": 1125,
	"./Cursive/lowerP/p_wdt_c_6.mp3": 1126,
	"./Cursive/lowerP/p_wdt_c_7.mp3": 1127,
	"./Cursive/lowerPA/pa_0.mp3": 1128,
	"./Cursive/lowerPA/pa_1.mp3": 1129,
	"./Cursive/lowerPA/pa_2.mp3": 1130,
	"./Cursive/lowerPA/pa_3.mp3": 1131,
	"./Cursive/lowerPA/pa_4.mp3": 1132,
	"./Cursive/lowerPA/pa_5.mp3": 1133,
	"./Cursive/lowerPA/pa_6.mp3": 1134,
	"./Cursive/lowerPA/pa_7.mp3": 1135,
	"./Cursive/lowerPA/pa_8.mp3": 1136,
	"./Cursive/lowerPA/pa_9.mp3": 1137,
	"./Cursive/lowerQ/Snd_TryQ.mp3": 1138,
	"./Cursive/lowerQ/q_wdt_c_0.mp3": 1139,
	"./Cursive/lowerQ/q_wdt_c_1.mp3": 1140,
	"./Cursive/lowerQ/q_wdt_c_1_2.mp3": 1141,
	"./Cursive/lowerQ/q_wdt_c_2.mp3": 1142,
	"./Cursive/lowerQ/q_wdt_c_3.mp3": 1143,
	"./Cursive/lowerQ/q_wdt_c_4.mp3": 1144,
	"./Cursive/lowerQ/q_wdt_c_4_5.mp3": 1145,
	"./Cursive/lowerQ/q_wdt_c_5.mp3": 1146,
	"./Cursive/lowerQ/q_wdt_c_6.mp3": 1147,
	"./Cursive/lowerR/Snd_TryR.mp3": 1148,
	"./Cursive/lowerR/r_wdt_c_0.mp3": 1149,
	"./Cursive/lowerR/r_wdt_c_0_1.mp3": 1150,
	"./Cursive/lowerR/r_wdt_c_1.mp3": 1151,
	"./Cursive/lowerR/r_wdt_c_2.mp3": 1152,
	"./Cursive/lowerR/r_wdt_c_3.mp3": 1153,
	"./Cursive/lowerR/r_wdt_c_3_4.mp3": 1154,
	"./Cursive/lowerR/r_wdt_c_4.mp3": 1155,
	"./Cursive/lowerR/r_wdt_c_5.mp3": 1156,
	"./Cursive/lowerS/Snd_TryS.mp3": 1157,
	"./Cursive/lowerS/s_wdt_c_0.mp3": 1158,
	"./Cursive/lowerS/s_wdt_c_0_1.mp3": 1159,
	"./Cursive/lowerS/s_wdt_c_1.mp3": 1160,
	"./Cursive/lowerS/s_wdt_c_2.mp3": 1161,
	"./Cursive/lowerS/s_wdt_c_3.mp3": 1162,
	"./Cursive/lowerS/s_wdt_c_3_4.mp3": 1163,
	"./Cursive/lowerS/s_wdt_c_4.mp3": 1164,
	"./Cursive/lowerS/s_wdt_c_5.mp3": 1165,
	"./Cursive/lowerT/Snd_TryT.mp3": 1166,
	"./Cursive/lowerT/t_wdt_c_0.mp3": 1167,
	"./Cursive/lowerT/t_wdt_c_1.mp3": 1168,
	"./Cursive/lowerT/t_wdt_c_1_2.mp3": 1169,
	"./Cursive/lowerT/t_wdt_c_2.mp3": 1170,
	"./Cursive/lowerT/t_wdt_c_3.mp3": 1171,
	"./Cursive/lowerT/t_wdt_c_4.mp3": 1172,
	"./Cursive/lowerTR/tr_0.mp3": 1173,
	"./Cursive/lowerTR/tr_1.mp3": 1174,
	"./Cursive/lowerTR/tr_2.mp3": 1175,
	"./Cursive/lowerTR/tr_3.mp3": 1176,
	"./Cursive/lowerTR/tr_4.mp3": 1177,
	"./Cursive/lowerTR/tr_5.mp3": 1178,
	"./Cursive/lowerTR/tr_7.mp3": 1179,
	"./Cursive/lowerU/Snd_TryU.mp3": 1180,
	"./Cursive/lowerU/u_wdt_c_0.mp3": 1181,
	"./Cursive/lowerU/u_wdt_c_1.mp3": 1182,
	"./Cursive/lowerU/u_wdt_c_1_2.mp3": 1183,
	"./Cursive/lowerU/u_wdt_c_2.mp3": 1184,
	"./Cursive/lowerU/u_wdt_c_3.mp3": 1185,
	"./Cursive/lowerU/u_wdt_c_3_4.mp3": 1186,
	"./Cursive/lowerU/u_wdt_c_4.mp3": 1187,
	"./Cursive/lowerU/u_wdt_c_5.mp3": 1188,
	"./Cursive/lowerUS/us_0.mp3": 1189,
	"./Cursive/lowerUS/us_1.mp3": 1190,
	"./Cursive/lowerUS/us_2.mp3": 1191,
	"./Cursive/lowerUS/us_3.mp3": 1192,
	"./Cursive/lowerUS/us_4.mp3": 1193,
	"./Cursive/lowerUS/us_5.mp3": 1194,
	"./Cursive/lowerUS/us_6.mp3": 1195,
	"./Cursive/lowerV/Snd_TryV.mp3": 1196,
	"./Cursive/lowerV/v_wdt_c_0.mp3": 1197,
	"./Cursive/lowerV/v_wdt_c_1.mp3": 1198,
	"./Cursive/lowerV/v_wdt_c_2.mp3": 1199,
	"./Cursive/lowerVE/ve_0.mp3": 1200,
	"./Cursive/lowerVE/ve_2.mp3": 1201,
	"./Cursive/lowerVE/ve_3.mp3": 1202,
	"./Cursive/lowerVE/ve_4.mp3": 1203,
	"./Cursive/lowerVE/ve_5.mp3": 1204,
	"./Cursive/lowerW/Snd_TryW.mp3": 1205,
	"./Cursive/lowerW/w_wdt_c_0.mp3": 1206,
	"./Cursive/lowerW/w_wdt_c_1.mp3": 1207,
	"./Cursive/lowerW/w_wdt_c_2.mp3": 1208,
	"./Cursive/lowerWA/wa_0.mp3": 1209,
	"./Cursive/lowerWA/wa_2.mp3": 1210,
	"./Cursive/lowerWA/wa_4.mp3": 1211,
	"./Cursive/lowerWA/wa_5.mp3": 1212,
	"./Cursive/lowerWA/wa_6.mp3": 1213,
	"./Cursive/lowerWA/wa_7.mp3": 1214,
	"./Cursive/lowerWA/wa_8.mp3": 1215,
	"./Cursive/lowerWH/wh_0.mp3": 1216,
	"./Cursive/lowerWH/wh_2.mp3": 1217,
	"./Cursive/lowerWH/wh_4.mp3": 1218,
	"./Cursive/lowerWH/wh_5.mp3": 1219,
	"./Cursive/lowerWH/wh_6.mp3": 1220,
	"./Cursive/lowerWH/wh_7.mp3": 1221,
	"./Cursive/lowerWH/wh_8.mp3": 1222,
	"./Cursive/lowerWI/wi_0.mp3": 1223,
	"./Cursive/lowerWI/wi_2.mp3": 1224,
	"./Cursive/lowerWI/wi_4.mp3": 1225,
	"./Cursive/lowerWI/wi_5.mp3": 1226,
	"./Cursive/lowerWI/wi_6.mp3": 1227,
	"./Cursive/lowerWI/wi_8.mp3": 1228,
	"./Cursive/lowerX/Snd_TryX.mp3": 1229,
	"./Cursive/lowerX/x_wdt_c_0.mp3": 1230,
	"./Cursive/lowerX/x_wdt_c_0_1.mp3": 1231,
	"./Cursive/lowerX/x_wdt_c_1.mp3": 1232,
	"./Cursive/lowerX/x_wdt_c_2.mp3": 1233,
	"./Cursive/lowerX/x_wdt_c_3.mp3": 1234,
	"./Cursive/lowerY/Snd_TryY.mp3": 1235,
	"./Cursive/lowerY/y_wdt_c_0.mp3": 1236,
	"./Cursive/lowerY/y_wdt_c_1.mp3": 1237,
	"./Cursive/lowerY/y_wdt_c_2.mp3": 1238,
	"./Cursive/lowerY/y_wdt_c_3.mp3": 1239,
	"./Cursive/lowerY/y_wdt_c_4.mp3": 1240,
	"./Cursive/lowerY/y_wdt_c_5.mp3": 1241,
	"./Cursive/lowerY/y_wdt_c_6.mp3": 1242,
	"./Cursive/lowerYO/yo_0.mp3": 1243,
	"./Cursive/lowerYO/yo_1.mp3": 1244,
	"./Cursive/lowerYO/yo_2.mp3": 1245,
	"./Cursive/lowerYO/yo_3.mp3": 1246,
	"./Cursive/lowerYO/yo_4.mp3": 1247,
	"./Cursive/lowerYO/yo_5.mp3": 1248,
	"./Cursive/lowerYO/yo_6.mp3": 1249,
	"./Cursive/lowerYO/yo_7.mp3": 1250,
	"./Cursive/lowerYO/yo_8.mp3": 1251,
	"./Cursive/lowerYO/yo_9.mp3": 1252,
	"./Cursive/lowerZ/Snd_TryZ.mp3": 1253,
	"./Cursive/lowerZ/z_wdt_c_0.mp3": 1254,
	"./Cursive/lowerZ/z_wdt_c_1.mp3": 1255,
	"./Cursive/lowerZ/z_wdt_c_2.mp3": 1256,
	"./Cursive/lowerZ/z_wdt_c_2_3.mp3": 1257,
	"./Cursive/lowerZ/z_wdt_c_3.mp3": 1258,
	"./Cursive/lowerZ/z_wdt_c_4.mp3": 1259,
	"./Letters-Numbers/0/Snd_01.mp3": 1260,
	"./Letters-Numbers/0/Snd_02.mp3": 1261,
	"./Letters-Numbers/0/Snd_03.mp3": 1262,
	"./Letters-Numbers/0/Snd_C0.mp3": 1263,
	"./Letters-Numbers/0/Snd_Try0.mp3": 1264,
	"./Letters-Numbers/1/Snd11.mp3": 1265,
	"./Letters-Numbers/1/Snd12.mp3": 1266,
	"./Letters-Numbers/1/Snd_1_Starts.mp3": 1267,
	"./Letters-Numbers/1/Snd_C1.mp3": 1268,
	"./Letters-Numbers/1/Snd_Try1.mp3": 1269,
	"./Letters-Numbers/2/Snd_21.mp3": 1270,
	"./Letters-Numbers/2/Snd_22.mp3": 1271,
	"./Letters-Numbers/2/Snd_23.mp3": 1272,
	"./Letters-Numbers/2/Snd_2_Starts.mp3": 1273,
	"./Letters-Numbers/2/Snd_C2.mp3": 1274,
	"./Letters-Numbers/2/Snd_Try2.mp3": 1275,
	"./Letters-Numbers/3/Snd_1.mp3": 1276,
	"./Letters-Numbers/3/Snd_2.mp3": 1277,
	"./Letters-Numbers/3/Snd_3.mp3": 1278,
	"./Letters-Numbers/3/Snd_3_Starts.mp3": 1279,
	"./Letters-Numbers/3/Snd_C3.mp3": 1280,
	"./Letters-Numbers/3/Snd_Try3.mp3": 1281,
	"./Letters-Numbers/4/Snd41.mp3": 1282,
	"./Letters-Numbers/4/Snd42.mp3": 1283,
	"./Letters-Numbers/4/Snd43.mp3": 1284,
	"./Letters-Numbers/4/Snd44.mp3": 1285,
	"./Letters-Numbers/4/Snd_4_Starts.mp3": 1286,
	"./Letters-Numbers/4/Snd_C4.mp3": 1287,
	"./Letters-Numbers/4/Snd_Try4.mp3": 1288,
	"./Letters-Numbers/5/Snd1.mp3": 1289,
	"./Letters-Numbers/5/Snd2.mp3": 1290,
	"./Letters-Numbers/5/Snd3.mp3": 1291,
	"./Letters-Numbers/5/Snd4.mp3": 1292,
	"./Letters-Numbers/5/Snd_5_Starts.mp3": 1293,
	"./Letters-Numbers/5/Snd_C5.mp3": 1294,
	"./Letters-Numbers/5/Snd_Try5.mp3": 1295,
	"./Letters-Numbers/6/Snd1.mp3": 1296,
	"./Letters-Numbers/6/Snd2.mp3": 1297,
	"./Letters-Numbers/6/Snd3.mp3": 1298,
	"./Letters-Numbers/6/Snd4.mp3": 1299,
	"./Letters-Numbers/6/Snd_6_Starts.mp3": 1300,
	"./Letters-Numbers/6/Snd_C6.mp3": 1301,
	"./Letters-Numbers/6/Snd_Try6.mp3": 1302,
	"./Letters-Numbers/7/Snd1.mp3": 1303,
	"./Letters-Numbers/7/Snd2.mp3": 1304,
	"./Letters-Numbers/7/Snd3.mp3": 1305,
	"./Letters-Numbers/7/Snd4.mp3": 1306,
	"./Letters-Numbers/7/Snd_7_Starts.mp3": 1307,
	"./Letters-Numbers/7/Snd_C7.mp3": 1308,
	"./Letters-Numbers/7/Snd_Try7.mp3": 1309,
	"./Letters-Numbers/8/Snd1.mp3": 1310,
	"./Letters-Numbers/8/Snd2.mp3": 1311,
	"./Letters-Numbers/8/Snd3.mp3": 1312,
	"./Letters-Numbers/8/Snd4.mp3": 1313,
	"./Letters-Numbers/8/Snd_8_Starts.mp3": 1314,
	"./Letters-Numbers/8/Snd_C8.mp3": 1315,
	"./Letters-Numbers/8/Snd_Try8.mp3": 1316,
	"./Letters-Numbers/9/Snd1.mp3": 1317,
	"./Letters-Numbers/9/Snd2.mp3": 1318,
	"./Letters-Numbers/9/Snd3.mp3": 1319,
	"./Letters-Numbers/9/Snd4.mp3": 1320,
	"./Letters-Numbers/9/Snd_9_Starts.mp3": 1321,
	"./Letters-Numbers/9/Snd_C9.mp3": 1322,
	"./Letters-Numbers/9/Snd_Try9.mp3": 1323,
	"./Letters-Numbers/A/Snd_A_Starts.mp3": 1324,
	"./Letters-Numbers/A/Snd_BigLineDownCorner.mp3": 1325,
	"./Letters-Numbers/A/Snd_CA.mp3": 1326,
	"./Letters-Numbers/A/Snd_LittleLineMiddle.mp3": 1327,
	"./Letters-Numbers/A/Snd_StartAtTop.mp3": 1328,
	"./Letters-Numbers/A/Snd_TryA.mp3": 1329,
	"./Letters-Numbers/B/Snd_B_Starts.mp3": 1330,
	"./Letters-Numbers/B/Snd_BigLineDown.mp3": 1331,
	"./Letters-Numbers/B/Snd_CB.mp3": 1332,
	"./Letters-Numbers/B/Snd_FrogJump.mp3": 1333,
	"./Letters-Numbers/B/Snd_TryB.mp3": 1334,
	"./Letters-Numbers/B/Snd_b4.mp3": 1335,
	"./Letters-Numbers/B/Snd_b5.mp3": 1336,
	"./Letters-Numbers/C/Snd_CC.mp3": 1337,
	"./Letters-Numbers/C/Snd_C_Starts.mp3": 1338,
	"./Letters-Numbers/C/Snd_TryC.mp3": 1339,
	"./Letters-Numbers/C/Snd_c2.mp3": 1340,
	"./Letters-Numbers/C/Snd_d4.mp3": 1341,
	"./Letters-Numbers/D/Snd_BigLineDown.mp3": 1342,
	"./Letters-Numbers/D/Snd_CD.mp3": 1343,
	"./Letters-Numbers/D/Snd_D_Starts.mp3": 1344,
	"./Letters-Numbers/D/Snd_FrogJump.mp3": 1345,
	"./Letters-Numbers/D/Snd_TryD.mp3": 1346,
	"./Letters-Numbers/D/Snd_d4.mp3": 1347,
	"./Letters-Numbers/E/Snd_BigLineDown.mp3": 1348,
	"./Letters-Numbers/E/Snd_CE.mp3": 1349,
	"./Letters-Numbers/E/Snd_E_Starts.mp3": 1350,
	"./Letters-Numbers/E/Snd_FrogJump.mp3": 1351,
	"./Letters-Numbers/E/Snd_TryE.mp3": 1352,
	"./Letters-Numbers/E/Snd_e4.mp3": 1353,
	"./Letters-Numbers/E/Snd_e5.mp3": 1354,
	"./Letters-Numbers/E/Snd_e6.mp3": 1355,
	"./Letters-Numbers/F/BigLineDown.mp3": 1356,
	"./Letters-Numbers/F/FrogJump.mp3": 1357,
	"./Letters-Numbers/F/Snd4.mp3": 1358,
	"./Letters-Numbers/F/Snd5.mp3": 1359,
	"./Letters-Numbers/F/Snd_CF.mp3": 1360,
	"./Letters-Numbers/F/Snd_F_Starts.mp3": 1361,
	"./Letters-Numbers/F/Snd_TryF.mp3": 1362,
	"./Letters-Numbers/F/Snd_e6.mp3": 1363,
	"./Letters-Numbers/G/Snd_CG.mp3": 1364,
	"./Letters-Numbers/G/Snd_G_Starts.mp3": 1365,
	"./Letters-Numbers/G/Snd_TryG.mp3": 1366,
	"./Letters-Numbers/G/Snd_e6.mp3": 1367,
	"./Letters-Numbers/G/Snd_g1.mp3": 1368,
	"./Letters-Numbers/G/Snd_g2.mp3": 1369,
	"./Letters-Numbers/G/Snd_g3.mp3": 1370,
	"./Letters-Numbers/G/Snd_g4.mp3": 1371,
	"./Letters-Numbers/H/BigLineDown.mp3": 1372,
	"./Letters-Numbers/H/FrogJump.mp3": 1373,
	"./Letters-Numbers/H/Snd1.mp3": 1374,
	"./Letters-Numbers/H/Snd2.mp3": 1375,
	"./Letters-Numbers/H/Snd3.mp3": 1376,
	"./Letters-Numbers/H/Snd_CH.mp3": 1377,
	"./Letters-Numbers/H/Snd_H_Starts.mp3": 1378,
	"./Letters-Numbers/H/Snd_TryH.mp3": 1379,
	"./Letters-Numbers/I/BigLineDown.mp3": 1380,
	"./Letters-Numbers/I/FrogJump.mp3": 1381,
	"./Letters-Numbers/I/Snd1.mp3": 1382,
	"./Letters-Numbers/I/Snd2.mp3": 1383,
	"./Letters-Numbers/I/Snd3.mp3": 1384,
	"./Letters-Numbers/I/Snd4.mp3": 1385,
	"./Letters-Numbers/I/Snd_CI.mp3": 1386,
	"./Letters-Numbers/I/Snd_I_Starts.mp3": 1387,
	"./Letters-Numbers/I/Snd_TryI.mp3": 1388,
	"./Letters-Numbers/J/Snd1.mp3": 1389,
	"./Letters-Numbers/J/Snd2.mp3": 1390,
	"./Letters-Numbers/J/Snd3.mp3": 1391,
	"./Letters-Numbers/J/Snd4.mp3": 1392,
	"./Letters-Numbers/J/Snd_CJ.mp3": 1393,
	"./Letters-Numbers/J/Snd_J_Starts.mp3": 1394,
	"./Letters-Numbers/J/Snd_TryJ.mp3": 1395,
	"./Letters-Numbers/K/Snd1.mp3": 1396,
	"./Letters-Numbers/K/Snd2.mp3": 1397,
	"./Letters-Numbers/K/Snd3.mp3": 1398,
	"./Letters-Numbers/K/Snd4.mp3": 1399,
	"./Letters-Numbers/K/Snd5.mp3": 1400,
	"./Letters-Numbers/K/Snd_CK.mp3": 1401,
	"./Letters-Numbers/K/Snd_K_Starts.mp3": 1402,
	"./Letters-Numbers/K/Snd_TryK.mp3": 1403,
	"./Letters-Numbers/L/Snd1.mp3": 1404,
	"./Letters-Numbers/L/Snd2.mp3": 1405,
	"./Letters-Numbers/L/Snd3.mp3": 1406,
	"./Letters-Numbers/L/Snd5.mp3": 1407,
	"./Letters-Numbers/L/Snd_CL.mp3": 1408,
	"./Letters-Numbers/L/Snd_L_Starts.mp3": 1409,
	"./Letters-Numbers/L/Snd_Lizzard.mp3": 1410,
	"./Letters-Numbers/L/Snd_TryL.mp3": 1411,
	"./Letters-Numbers/M/Snd1.mp3": 1412,
	"./Letters-Numbers/M/Snd4.mp3": 1413,
	"./Letters-Numbers/M/Snd5.mp3": 1414,
	"./Letters-Numbers/M/Snd6.mp3": 1415,
	"./Letters-Numbers/M/Snd_CM.mp3": 1416,
	"./Letters-Numbers/M/Snd_FrogJump.mp3": 1417,
	"./Letters-Numbers/M/Snd_M_Starts.mp3": 1418,
	"./Letters-Numbers/M/Snd_TryM.mp3": 1419,
	"./Letters-Numbers/M/Snd_bigLineDown.mp3": 1420,
	"./Letters-Numbers/N/Snd1.mp3": 1421,
	"./Letters-Numbers/N/Snd4.mp3": 1422,
	"./Letters-Numbers/N/Snd5.mp3": 1423,
	"./Letters-Numbers/N/Snd_CN.mp3": 1424,
	"./Letters-Numbers/N/Snd_FrogJump.mp3": 1425,
	"./Letters-Numbers/N/Snd_N_Starts.mp3": 1426,
	"./Letters-Numbers/N/Snd_TryN.mp3": 1427,
	"./Letters-Numbers/N/Snd_bigLineDown.mp3": 1428,
	"./Letters-Numbers/O/NowYouTry.mp3": 1429,
	"./Letters-Numbers/O/Snd5.mp3": 1430,
	"./Letters-Numbers/O/Snd_CO.mp3": 1431,
	"./Letters-Numbers/O/Snd_FirstWatchMe.mp3": 1432,
	"./Letters-Numbers/O/Snd_NowYouTry.mp3": 1433,
	"./Letters-Numbers/O/Snd_O_Starts.mp3": 1434,
	"./Letters-Numbers/O/Snd_TryC.mp3": 1435,
	"./Letters-Numbers/O/Snd_TryO.mp3": 1436,
	"./Letters-Numbers/O/Snd_o1.mp3": 1437,
	"./Letters-Numbers/O/Snd_o2.mp3": 1438,
	"./Letters-Numbers/O/Snd_o3.mp3": 1439,
	"./Letters-Numbers/P/BigLineDown.mp3": 1440,
	"./Letters-Numbers/P/FrogJump.mp3": 1441,
	"./Letters-Numbers/P/Snd1.mp3": 1442,
	"./Letters-Numbers/P/Snd2.mp3": 1443,
	"./Letters-Numbers/P/Snd4.mp3": 1444,
	"./Letters-Numbers/P/Snd_CP.mp3": 1445,
	"./Letters-Numbers/P/Snd_P_Starts.mp3": 1446,
	"./Letters-Numbers/P/Snd_TryP.mp3": 1447,
	"./Letters-Numbers/Q/Snd_CQ.mp3": 1448,
	"./Letters-Numbers/Q/Snd_Q_Starts.mp3": 1449,
	"./Letters-Numbers/Q/Snd_TryQ.mp3": 1450,
	"./Letters-Numbers/Q/Snd_q1.mp3": 1451,
	"./Letters-Numbers/Q/Snd_q2.mp3": 1452,
	"./Letters-Numbers/Q/Snd_q3.mp3": 1453,
	"./Letters-Numbers/Q/Snd_q4.mp3": 1454,
	"./Letters-Numbers/R/BigLineDown.mp3": 1455,
	"./Letters-Numbers/R/FrogJump.mp3": 1456,
	"./Letters-Numbers/R/Snd1.mp3": 1457,
	"./Letters-Numbers/R/Snd4.mp3": 1458,
	"./Letters-Numbers/R/Snd5.mp3": 1459,
	"./Letters-Numbers/R/Snd_CR.mp3": 1460,
	"./Letters-Numbers/R/Snd_R_Starts.mp3": 1461,
	"./Letters-Numbers/R/Snd_TryR.mp3": 1462,
	"./Letters-Numbers/S/Snd4.mp3": 1463,
	"./Letters-Numbers/S/Snd5.mp3": 1464,
	"./Letters-Numbers/S/Snd_CS.mp3": 1465,
	"./Letters-Numbers/S/Snd_S_Starts.mp3": 1466,
	"./Letters-Numbers/S/Snd_TryS.mp3": 1467,
	"./Letters-Numbers/S/Snd_s1.mp3": 1468,
	"./Letters-Numbers/S/Snd_s2.mp3": 1469,
	"./Letters-Numbers/T/Snd1.mp3": 1470,
	"./Letters-Numbers/T/Snd2.mp3": 1471,
	"./Letters-Numbers/T/Snd3.mp3": 1472,
	"./Letters-Numbers/T/Snd5.mp3": 1473,
	"./Letters-Numbers/T/Snd_CT.mp3": 1474,
	"./Letters-Numbers/T/Snd_T_Starts.mp3": 1475,
	"./Letters-Numbers/T/Snd_TryT.mp3": 1476,
	"./Letters-Numbers/U/Snd1.mp3": 1477,
	"./Letters-Numbers/U/Snd2.mp3": 1478,
	"./Letters-Numbers/U/Snd3.mp3": 1479,
	"./Letters-Numbers/U/Snd5.mp3": 1480,
	"./Letters-Numbers/U/Snd_CU.mp3": 1481,
	"./Letters-Numbers/U/Snd_TryU.mp3": 1482,
	"./Letters-Numbers/U/Snd_U_Starts.mp3": 1483,
	"./Letters-Numbers/V/Snd1.mp3": 1484,
	"./Letters-Numbers/V/Snd2.mp3": 1485,
	"./Letters-Numbers/V/Snd3.mp3": 1486,
	"./Letters-Numbers/V/Snd5.mp3": 1487,
	"./Letters-Numbers/V/Snd_CV.mp3": 1488,
	"./Letters-Numbers/V/Snd_TryV.mp3": 1489,
	"./Letters-Numbers/V/Snd_V_Starts.mp3": 1490,
	"./Letters-Numbers/W/Snd1.mp3": 1491,
	"./Letters-Numbers/W/Snd2.mp3": 1492,
	"./Letters-Numbers/W/Snd3.mp3": 1493,
	"./Letters-Numbers/W/Snd4.mp3": 1494,
	"./Letters-Numbers/W/Snd5.mp3": 1495,
	"./Letters-Numbers/W/Snd_CW.mp3": 1496,
	"./Letters-Numbers/W/Snd_TryW.mp3": 1497,
	"./Letters-Numbers/W/Snd_W_Starts.mp3": 1498,
	"./Letters-Numbers/X/Snd1.mp3": 1499,
	"./Letters-Numbers/X/Snd2.mp3": 1500,
	"./Letters-Numbers/X/Snd3.mp3": 1501,
	"./Letters-Numbers/X/Snd4.mp3": 1502,
	"./Letters-Numbers/X/Snd_CX.mp3": 1503,
	"./Letters-Numbers/X/Snd_TryX.mp3": 1504,
	"./Letters-Numbers/X/Snd_X_Starts.mp3": 1505,
	"./Letters-Numbers/Y/Snd1.mp3": 1506,
	"./Letters-Numbers/Y/Snd2.mp3": 1507,
	"./Letters-Numbers/Y/Snd3.mp3": 1508,
	"./Letters-Numbers/Y/Snd4.mp3": 1509,
	"./Letters-Numbers/Y/Snd_CY.mp3": 1510,
	"./Letters-Numbers/Y/Snd_TryY.mp3": 1511,
	"./Letters-Numbers/Z/Snd1.mp3": 1512,
	"./Letters-Numbers/Z/Snd2.mp3": 1513,
	"./Letters-Numbers/Z/Snd3.mp3": 1514,
	"./Letters-Numbers/Z/Snd4.mp3": 1515,
	"./Letters-Numbers/Z/Snd_CZ.mp3": 1516,
	"./Letters-Numbers/Z/Snd_TryZ.mp3": 1517,
	"./Letters-Numbers/Z/Snd_Z_Starts.mp3": 1518,
	"./Letters-Numbers/all-letters/first-watch-me.mp3": 1519,
	"./Letters-Numbers/all-letters/now-you-try.mp3": 1520,
	"./Letters-Numbers/all-numbers/first-watch-me.mp3": 1521,
	"./Letters-Numbers/all-numbers/now-you-try.mp3": 1522,
	"./Letters-Numbers/lowerA/Snd_Backdown.mp3": 1523,
	"./Letters-Numbers/lowerA/Snd_ClowerA.mp3": 1524,
	"./Letters-Numbers/lowerA/Snd_LowerAHelicopter.mp3": 1525,
	"./Letters-Numbers/lowerA/Snd_MagicC.mp3": 1526,
	"./Letters-Numbers/lowerA/Snd_TryA.mp3": 1527,
	"./Letters-Numbers/lowerB/SndLowerBAroundBump.mp3": 1528,
	"./Letters-Numbers/lowerB/SndLowerBDiveDown.mp3": 1529,
	"./Letters-Numbers/lowerB/SndLowerBSwimUpOver.mp3": 1530,
	"./Letters-Numbers/lowerB/Snd_ClowerB.mp3": 1531,
	"./Letters-Numbers/lowerB/Snd_TryB.mp3": 1532,
	"./Letters-Numbers/lowerC/SndLowerBAroundBump.mp3": 1533,
	"./Letters-Numbers/lowerC/SndLowerCMagicC.mp3": 1534,
	"./Letters-Numbers/lowerC/Snd_ClowerC.mp3": 1535,
	"./Letters-Numbers/lowerC/Snd_TryC.mp3": 1536,
	"./Letters-Numbers/lowerD/Snd_ClowerD.mp3": 1537,
	"./Letters-Numbers/lowerD/Snd_LowerDDownBump.mp3": 1538,
	"./Letters-Numbers/lowerD/Snd_LowerDHelicopter.mp3": 1539,
	"./Letters-Numbers/lowerD/Snd_LowerDMagicC.mp3": 1540,
	"./Letters-Numbers/lowerD/Snd_LowerDUpHigher.mp3": 1541,
	"./Letters-Numbers/lowerD/Snd_TryD.mp3": 1542,
	"./Letters-Numbers/lowerE/Snd_ClowerE.mp3": 1543,
	"./Letters-Numbers/lowerE/Snd_LowerDDownBump.mp3": 1544,
	"./Letters-Numbers/lowerE/Snd_LowerEBall.mp3": 1545,
	"./Letters-Numbers/lowerE/Snd_LowerEBases.mp3": 1546,
	"./Letters-Numbers/lowerE/Snd_TryE.mp3": 1547,
	"./Letters-Numbers/lowerF/Snd_ClowerF.mp3": 1548,
	"./Letters-Numbers/lowerF/Snd_LowerDDownBump.mp3": 1549,
	"./Letters-Numbers/lowerF/Snd_LowerFCross.mp3": 1550,
	"./Letters-Numbers/lowerF/Snd_LowerFUpDown.mp3": 1551,
	"./Letters-Numbers/lowerF/Snd_TryF.mp3": 1552,
	"./Letters-Numbers/lowerG/Snd_ClowerG.mp3": 1553,
	"./Letters-Numbers/lowerG/Snd_LowerDDownBump.mp3": 1554,
	"./Letters-Numbers/lowerG/Snd_LowerGBackdown.mp3": 1555,
	"./Letters-Numbers/lowerG/Snd_LowerGHelicopter.mp3": 1556,
	"./Letters-Numbers/lowerG/Snd_LowerGMagicC.mp3": 1557,
	"./Letters-Numbers/lowerG/Snd_LowerGTurn.mp3": 1558,
	"./Letters-Numbers/lowerG/Snd_TryG.mp3": 1559,
	"./Letters-Numbers/lowerH/Snd_ClowerH.mp3": 1560,
	"./Letters-Numbers/lowerH/Snd_LowerHDivedown.mp3": 1561,
	"./Letters-Numbers/lowerH/Snd_LowerHSwim.mp3": 1562,
	"./Letters-Numbers/lowerH/Snd_TryH.mp3": 1563,
	"./Letters-Numbers/lowerI/Snd_ClowerI.mp3": 1564,
	"./Letters-Numbers/lowerI/Snd_LowerIDot.mp3": 1565,
	"./Letters-Numbers/lowerI/Snd_LowerIDown.mp3": 1566,
	"./Letters-Numbers/lowerI/Snd_TryI.mp3": 1567,
	"./Letters-Numbers/lowerJ/SndLowerJDot.mp3": 1568,
	"./Letters-Numbers/lowerJ/SndLowerJDown.mp3": 1569,
	"./Letters-Numbers/lowerJ/SndLowerJTurn.mp3": 1570,
	"./Letters-Numbers/lowerJ/Snd_ClowerJ.mp3": 1571,
	"./Letters-Numbers/lowerJ/Snd_TryJ.mp3": 1572,
	"./Letters-Numbers/lowerK/SndLowerKDownBumpLine.mp3": 1573,
	"./Letters-Numbers/lowerK/SndLowerKKick.mp3": 1574,
	"./Letters-Numbers/lowerK/SndLowerKSlideAway.mp3": 1575,
	"./Letters-Numbers/lowerK/Snd_ClowerK.mp3": 1576,
	"./Letters-Numbers/lowerK/Snd_TryK.mp3": 1577,
	"./Letters-Numbers/lowerL/SndLowerKKick.mp3": 1578,
	"./Letters-Numbers/lowerL/SndLowerKSlideAway.mp3": 1579,
	"./Letters-Numbers/lowerL/SndLowerLDownBumpLine.mp3": 1580,
	"./Letters-Numbers/lowerL/Snd_ClowerL.mp3": 1581,
	"./Letters-Numbers/lowerL/Snd_TryL.mp3": 1582,
	"./Letters-Numbers/lowerM/Snd_ClowerM.mp3": 1583,
	"./Letters-Numbers/lowerM/Snd_LowerMDivedown.mp3": 1584,
	"./Letters-Numbers/lowerM/Snd_LowerMSwim.mp3": 1585,
	"./Letters-Numbers/lowerM/Snd_TryM.mp3": 1586,
	"./Letters-Numbers/lowerN/Snd_ClowerN.mp3": 1587,
	"./Letters-Numbers/lowerN/Snd_LowerNDivedown.mp3": 1588,
	"./Letters-Numbers/lowerN/Snd_LowerNSwim.mp3": 1589,
	"./Letters-Numbers/lowerN/Snd_TryN.mp3": 1590,
	"./Letters-Numbers/lowerO/LowerOStopTrimmed.mp3": 1591,
	"./Letters-Numbers/lowerO/SndLowerOKeepGoing.mp3": 1592,
	"./Letters-Numbers/lowerO/SndLowerOMagicC.mp3": 1593,
	"./Letters-Numbers/lowerO/SndLowerOStop.mp3": 1594,
	"./Letters-Numbers/lowerO/Snd_ClowerO.mp3": 1595,
	"./Letters-Numbers/lowerO/Snd_TryO.mp3": 1596,
	"./Letters-Numbers/lowerP/SndLowerPAroundBump.mp3": 1597,
	"./Letters-Numbers/lowerP/SndLowerPDiveDown.mp3": 1598,
	"./Letters-Numbers/lowerP/SndLowerPSwimUpOver.mp3": 1599,
	"./Letters-Numbers/lowerP/Snd_ClowerP.mp3": 1600,
	"./Letters-Numbers/lowerP/Snd_TryP.mp3": 1601,
	"./Letters-Numbers/lowerQ/Snd_ClowerQ.mp3": 1602,
	"./Letters-Numbers/lowerQ/Snd_LowerQBackdown.mp3": 1603,
	"./Letters-Numbers/lowerQ/Snd_LowerQHelicopter.mp3": 1604,
	"./Letters-Numbers/lowerQ/Snd_LowerQMagicC.mp3": 1605,
	"./Letters-Numbers/lowerQ/Snd_LowerQTurn.mp3": 1606,
	"./Letters-Numbers/lowerQ/Snd_TryQ.mp3": 1607,
	"./Letters-Numbers/lowerR/Snd_ClowerR.mp3": 1608,
	"./Letters-Numbers/lowerR/Snd_LowerQTurn.mp3": 1609,
	"./Letters-Numbers/lowerR/Snd_LowerRDivedown.mp3": 1610,
	"./Letters-Numbers/lowerR/Snd_LowerRSwim.mp3": 1611,
	"./Letters-Numbers/lowerR/Snd_TryR.mp3": 1612,
	"./Letters-Numbers/lowerS/SndLowerSCurveAround.mp3": 1613,
	"./Letters-Numbers/lowerS/SndLowerSLittleMagicC.mp3": 1614,
	"./Letters-Numbers/lowerS/SndLowerSTurnDowm.mp3": 1615,
	"./Letters-Numbers/lowerS/Snd_ClowerS.mp3": 1616,
	"./Letters-Numbers/lowerS/Snd_TryS.mp3": 1617,
	"./Letters-Numbers/lowerT/Snd_ClowerT.mp3": 1618,
	"./Letters-Numbers/lowerT/Snd_LowerTCross.mp3": 1619,
	"./Letters-Numbers/lowerT/Snd_LowerTUpDown.mp3": 1620,
	"./Letters-Numbers/lowerT/Snd_TryT.mp3": 1621,
	"./Letters-Numbers/lowerU/SndLowerUDownBump.mp3": 1622,
	"./Letters-Numbers/lowerU/SndLowerUDownTravelUpBump.mp3": 1623,
	"./Letters-Numbers/lowerU/Snd_ClowerU.mp3": 1624,
	"./Letters-Numbers/lowerU/Snd_TryU.mp3": 1625,
	"./Letters-Numbers/lowerV/Snd_ClowerV.mp3": 1626,
	"./Letters-Numbers/lowerV/Snd_LowerVSlidedown.mp3": 1627,
	"./Letters-Numbers/lowerV/Snd_LowerVSlideup.mp3": 1628,
	"./Letters-Numbers/lowerV/Snd_TryV.mp3": 1629,
	"./Letters-Numbers/lowerW/Snd_ClowerW.mp3": 1630,
	"./Letters-Numbers/lowerW/Snd_LowerWSlidedown.mp3": 1631,
	"./Letters-Numbers/lowerW/Snd_LowerWSlidedowna.mp3": 1632,
	"./Letters-Numbers/lowerW/Snd_LowerWSlideup.mp3": 1633,
	"./Letters-Numbers/lowerW/Snd_LowerWSlideupa.mp3": 1634,
	"./Letters-Numbers/lowerW/Snd_TryW.mp3": 1635,
	"./Letters-Numbers/lowerX/SndLowerXSlideDown.mp3": 1636,
	"./Letters-Numbers/lowerX/SndLowerXSlideDown2.mp3": 1637,
	"./Letters-Numbers/lowerX/Snd_ClowerX.mp3": 1638,
	"./Letters-Numbers/lowerX/Snd_LowerWSlideupa.mp3": 1639,
	"./Letters-Numbers/lowerX/Snd_TryX.mp3": 1640,
	"./Letters-Numbers/lowerY/SndLowerYSlideDown.mp3": 1641,
	"./Letters-Numbers/lowerY/SndLowerYSlideDown2.mp3": 1642,
	"./Letters-Numbers/lowerY/Snd_ClowerY.mp3": 1643,
	"./Letters-Numbers/lowerY/Snd_LowerWSlideupa.mp3": 1644,
	"./Letters-Numbers/lowerY/Snd_TryY.mp3": 1645,
	"./Letters-Numbers/lowerZ/SndLowerZGoAcross.mp3": 1646,
	"./Letters-Numbers/lowerZ/SndLowerZGoAcross2.mp3": 1647,
	"./Letters-Numbers/lowerZ/SndLowerZSlideDown.mp3": 1648,
	"./Letters-Numbers/lowerZ/Snd_ClowerZ.mp3": 1649,
	"./Letters-Numbers/lowerZ/Snd_TryZ.mp3": 1650
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 744;